<form (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
  <section mat-dialog-title>
    <button mat-dialog-close mat-icon-button matTooltip="Close.">
      <mat-icon>close</mat-icon>
    </button>
    <h1>
      <mat-icon>{{!!existingCategory && 'edit' || 'add' }}</mat-icon>
      {{ !!existingCategory && 'Edit' || 'Add' }} Category
    </h1>
  </section>
  <section mat-dialog-content>
    <mat-form-field>
      <mat-label>Parent Category</mat-label>
      <mat-select formControlName="parent_id">
        @for (category of existingCategories; track category) {
          <mat-option
            [value]="category.id"
            >{{category.title}}</mat-option
            >
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Title</mat-label>
        <input formControlName="title" matInput />
      </mat-form-field>
      <mat-form-field>
        <mat-label>Kind</mat-label>
        <mat-select formControlName="kind">
          <mat-option value="null">No parent category</mat-option>
          <mat-option value="offers">Offers</mat-option>
          <mat-option value="tickets">Tickets</mat-option>
          <mat-option value="featured">Featured</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Font Icon</mat-label>
        <input formControlName="font_icon" matInput />
      </mat-form-field>
      <div class="visibility">
        <h6>Category Visibility</h6>
        <mat-slide-toggle formControlName="web_only">Web only</mat-slide-toggle>
      </div>
      <div class="menu_display">
        <h6>Display in Menu</h6>
        <mat-slide-toggle formControlName="display_in_menu"></mat-slide-toggle>
      </div>
      <quill-editor
        class="form-control editor"
        formControlName="description"
      ></quill-editor>
      @if (files.controls.length < 1) {
        <div
          (click)="fileInput.click()"
          class="uploadfilecontainer"
          dragDropImages
          >
          <input #fileInput (change)="fileUpload($event)" hidden type="file" />
        </div>
      }
      <section class="files" formArrayName="files">
        @for (image of files.controls; track image) {
          <div class="image">
            <img [src]="image.value.src" alt="Uploaded image." />
            <button (click)="removeFile(image)" mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        }
      </section>
    </section>
    <section align="end" mat-dialog-actions>
      <button
        mat-button
        mat-dialog-close
        matTooltip="Cancel and close."
        type="button"
        >
        <mat-icon>cancel</mat-icon>
        Cancel
      </button>
      <button
        [disabled]="!form.valid"
        mat-button
        matTooltip="Save page."
        type="submit"
        >
        <mat-icon>save</mat-icon>
        Save
      </button>
    </section>
  </form>
